import { Button, TextInput } from '@inexture/core';
import imgEmail from '@/assets/img/newsletter/mail-ico.png';

const Newsletter = () => {
  return (
    <>
      <div className="pb-20">
        <div className="container">
          <div
            className="
              relative
              rounded-lg
              p-5
              border border-[#eff0f0]
              bg-[#F5F5F5]
            "
          >
            <div className="absolute left-[13px] top-[6px] z-0 pointer-events-none">
              <img className="max-w-[140px]" src={imgEmail} alt="email" />
            </div>
            <h3 className="text-[24px] relative z-[1] font-medium mb-3">
              Nieuwsbrief
            </h3>
            <div className="relative z-[1] flex items-center justify-between gap-5">
              <div className="max-w-[550px]">
                <p className="text-[14px] leading-relaxed mb-1">
                  Het zou zonde zijn mocht je een leuk voorstel missen!
                </p>
                <p className="text-[14px]  leading-relaxed mb-1">
                  Dankzij onze nieuwsbrief word jij een heuse VIP.
                </p>
              </div>

              <form className="flex flex-end">
                <TextInput
                  size="lg"
                  classNames={{ input: 'rounded-r-none!' }}
                  placeholder="Email"
                  w="250px"
                />
                <Button size="lg" classNames={{ root: 'rounded-l-none!' }}>
                  Registreer
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Newsletter;
